<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoCodeInAuthResponse` — no `code` parameter was
 * present in the OAuth callback fragment. Without the authorization code the
 * BFF cannot perform the token exchange. Delegates all rendering to
 * `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoCodeInAuthResponse" />
</template>
